export default __webpack_public_path__ + "static/media/cover.30610272.png";